var map = {
	"./AddAddress/router.js": "PFM6",
	"./AddressManage/router.js": "TQZf",
	"./Agreement/router.js": "28rf",
	"./AppDownload/router.js": "qAKg",
	"./Article/router.js": "pnD8",
	"./ArticleList/router.js": "xhPD",
	"./ByOther/router.js": "lcGy",
	"./ByOtherCart/router.js": "p3hl",
	"./Coupon/router.js": "WPYP",
	"./Draw/router.js": "m4BW",
	"./Fans/router.js": "vNWY",
	"./GoodsItem/router.js": "qLFf",
	"./GoodsOrder/router.js": "iYA7",
	"./Group/router.js": "/bIG",
	"./GroupOrderList/router.js": "zHmT",
	"./GroupRecord/router.js": "2jNP",
	"./Home/router.js": "tTmE",
	"./Join/router.js": "K47L",
	"./JoinInfo/router.js": "km1Z",
	"./Kind/router.js": "iM4Q",
	"./LegalRight/router.js": "y+/i",
	"./Login/router.js": "eqJq",
	"./LogisticsInfo/router.js": "8SYm",
	"./MoreTicket/router.js": "rJ+w",
	"./My/router.js": "y6GA",
	"./MyFollow2/router.js": "DBRl",
	"./Myfollow-old/router.js": "lLL0",
	"./Myfollow/router.js": "UACr",
	"./Myticket/router.js": "163t",
	"./NameSuccess/router.js": "xzX+",
	"./OrderComment/router.js": "+8Yh",
	"./OrderDetail/router.js": "SN4g",
	"./OrderList/router.js": "UOGA",
	"./PayPassword/router.js": "Qi5t",
	"./Payment/router.js": "b/p7",
	"./Protocol/router.js": "s/qR",
	"./RatioCenter/router.js": "wtWq",
	"./RatioDeal/router.js": "C+TO",
	"./RatioDidital/router.js": "N42t",
	"./RatioGoods/router.js": "s3XV",
	"./RatioNew/router.js": "WysJ",
	"./RatioNews/router.js": "9YFn",
	"./RatioOrder/router.js": "G7O6",
	"./RatioOrderDetail/router.js": "H6bH",
	"./RatioOrderDetails/router.js": "K8PQ",
	"./RatioPin/router.js": "AwDz",
	"./RatioPublish/router.js": "gV//",
	"./RatioQuota/router.js": "0y05",
	"./RatioShares/router.js": "NAfr",
	"./RatioTicket/router.js": "ehFE",
	"./RealNAme/router.js": "Dort",
	"./Record/router.js": "VMl2",
	"./Search/router.js": "p8YV",
	"./Serve/router.js": "dpCo",
	"./Setting/router.js": "MdoN",
	"./Share/router.js": "AMG+",
	"./Sign/router.js": "iWkx",
	"./Store/router.js": "Ff+9",
	"./StoreCardApplyList/router.js": "jyfP",
	"./StoreCardRecord/router.js": "6hQc",
	"./StoreCenter/router.js": "H7oA",
	"./StoreCenter2/router.js": "mdgY",
	"./StoreIndex/router.js": "d8g3",
	"./StoreSearch/router.js": "l8M8",
	"./Success/router.js": "mVls",
	"./WithDraw/router.js": "L7dI",
	"./WithDrawTran/router.js": "pBjZ",
	"./activity/router.js": "dZjq",
	"./cardRecord/router.js": "M45o",
	"./cash/router.js": "P3ys",
	"./changMobile/router.js": "wwF5",
	"./changeName/router.js": "SbE9",
	"./changePSW/router.js": "Be2r",
	"./changePayment/router.js": "BA73",
	"./changesj/router.js": "yDgB",
	"./checkCard/router.js": "a8Y0",
	"./getPaper/router.js": "zzHk",
	"./joinInfo2/router.js": "q6mP",
	"./myCard/router.js": "aTYq",
	"./register/router.js": "OFug",
	"./retrieve/router.js": "4fLP",
	"./shopCart/router.js": "Pity",
	"./shopCartOrder/router.js": "RHoq",
	"./signName/router.js": "OoDG",
	"./task/router.js": "D6GH",
	"./testQr/router.js": "2ZXs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w0qU";


//////////////////
// WEBPACK FOOTER
// ./src/views router\.js$
// module id = w0qU
// module chunks = 87